var map = {
	"./Alljoy-Donuts-12.jpg": 906,
	"./Alljoy-Donuts-25.jpg": 336,
	"./Alljoy-Donuts-30.jpg": 50,
	"./Alljoy-Donuts-36.jpg": 164,
	"./Alljoy-Donuts-40.jpg": 243,
	"./Alljoy-Donuts-51.jpg": 625,
	"./Alljoy-Donuts-54.jpg": 400,
	"./Alljoy-Donuts-71.jpg": 211,
	"./Screenshot-2024-08-04-at-12.49.28 PM.png": 447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 294;